import { parsePhoneNumber } from 'libphonenumber-js';
import { Country } from '../enums/Country';

export const formatPhoneNumber = (phoneNumber: string) => parsePhoneNumber(phoneNumber, 'US').formatInternational();

export const defaultCountries = [Country.US,
  Country.Canada,
  Country.UK,
  Country.France,
  Country.India,
  Country.Ukraine,
  Country.Australia,
  Country.NewZealand,
  Country.Brazil
];
